import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    height: 100%;
`;

export const CharRow = styled.div`
    font-family: "${props => props.font}";
    font-weight: bold;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    height: 30px;
    font-size: 18px;

    div:first-child {
        font-family: inherit;
        width: 150px;
    }

    div:nth-child(n+2) {
        font-family: inherit;
        width: 150px;
    }
`;